import {
  ApiBlockSettings,
  ApiSettings,
  ApiSlideSettings,
  BlockSettings,
  SlideSettings,
} from '../models/settings.model';
import { ContentType, UploadFieldName } from '../models/content.enum';

import { ApiResponse } from '../models/api.model';
import { DataService } from 'apps/arsultima/src/app/services/data.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL } from '../utils/url';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  constructor(private readonly http: HttpClient, private readonly dataService: DataService) {}

  // Settings
  getSettings(): Observable<ApiSettings> {
    let params = this.dataService.getParamsWithConnexion();
    return this.http
      .get<ApiResponse<ApiSettings>>(URL.getSettings, { params })
      .pipe(map(response => response.data));
  }

  uploadSlideBlock({
    id,
    type,
    field,
    file,
  }: {
    id: string;
    type: ContentType;
    field: UploadFieldName;
    file: File;
  }): Observable<ApiSlideSettings> {
    // xxxx.arsultima.com/api/v1/oeuvres/pic/4/upload?db=xxxx  (or : "/oeuvres/attach/4 ..." )
    const url = `${URL.uploadSettingsFile}/${type}/${field}/${id}/upload`;
    const params = this.dataService.getParamsWithConnexion();
    const formData: FormData = new FormData();
    formData.append('file', file);

    return this.http
      .post<ApiResponse<ApiSlideSettings>>(url, formData, { params })
      .pipe(map(response => response.data));
  }

  saveSlide(data: SlideSettings) {
    const id = data.reference ? data.reference : 0;
    const type = ContentType.slides;
    const url = `${URL.saveSettings}/${type}/${id}`;
    const params = this.dataService.getParamsWithConnexion();
    const submitData = new ApiSlideSettings(data);

    // don't pass this fields to prevent an error from the back
    delete submitData.ID;
    delete submitData.date_maj;

    return this.http
      .put<ApiResponse<ApiSlideSettings>>(url, { data: submitData }, { params })
      .pipe(map(response => response.data[type]));
  }

  saveBlock(data: BlockSettings) {
    const id = data.ID ? data.ID : 0;
    const type = ContentType.blocks;
    const url = `${URL.saveSettings}/${type}/${id}`;
    const params = this.dataService.getParamsWithConnexion();
    const submitData = new ApiBlockSettings(data);

    // don't pass this fields to prevent an error from the back
    delete submitData.ID;
    delete submitData.date_maj;

    return this.http
      .put<ApiResponse<ApiBlockSettings>>(url, { data: submitData }, { params })
      .pipe(map(response => response.data[type]));
  }

  deleteBlock(id: number) {
    const type = ContentType.blocks;
    const url = `${URL.saveSettings}/${type}/${id}`;
    const params = this.dataService.getParamsWithConnexion();

    return this.http.delete(url, { params });
  }

  deleteSlide(id: number) {
    const type = ContentType.slides;
    const url = `${URL.saveSettings}/${type}/${id}`;
    const params = this.dataService.getParamsWithConnexion();

    return this.http.delete(url, { params });
  }

  private rotate({
    id,
    numberOfRotation,
    type,
  }: {
    id: string;
    numberOfRotation: number;
    type: ContentType;
  }): Observable<any> {
    const rotate = `rotate${numberOfRotation}`;
    const url = `${URL.saveSettings}/${type}/${id}/${rotate}`;
    const params = this.dataService.getParamsWithConnexion();

    return this.http.put(url, {}, { params });
  }

  rotateBlock({ id, numberOfRotation }: { id: string; numberOfRotation: number }): Observable<any> {
    return this.rotate({ id, numberOfRotation, type: ContentType.blocks });
  }

  rotateSlide({ id, numberOfRotation }: { id: string; numberOfRotation: number }): Observable<any> {
    return this.rotate({ id, numberOfRotation, type: ContentType.slides });
  }
}
